import { ModalFactory } from '@rendora/common/features/modals/factory';
import { h } from 'vue';
import LoginContent from '../../modal-index.vue';

const symbolAccountLogin = Symbol('account-login');

/**
 * 账号登录弹窗 composable
 * 提供统一的账号登录弹窗管理功能
 */
export function useAccountLogin() {
  /**
   * 关闭
   */
  const close = () => {
    const modal = ModalFactory.getInstance(symbolAccountLogin);
    modal?.close();
  };

  /**
   * 显示
   * @param onConfirm 确认回调函数
   * @returns ModalInstance
   */
  const showModal = () => {
    // 检查是否已存在弹窗实例
    if (ModalFactory.hasModal(symbolAccountLogin)) {
      const modal = ModalFactory.getInstance(symbolAccountLogin);
      modal?.update({
        content: h(LoginContent, { onCancel: close }),
      });
      return modal;
    }

    // 创建新的弹窗实例
    const modal = ModalFactory.create(
      {
        title: ' ',
        width: '1088px',
        height: '680px',
        showHeader: false,
        showCloseButton: true,
        closeOnOverlayClick: false,
        closeOnEsc: true,
        maskClosable: false,
        centered: true,
        border: 'none',
        borderRadius: '12px',
        content: h(LoginContent, { onCancel: close }),
      },
      symbolAccountLogin,
    );

    return modal;
  };

  const show = () => {
    return showModal();
  };

  return {
    show,
    close,
  };
}
